export const ENVS = {
  LOCAL: 'local',
  DEV: 'dev',
  DEMO: 'demo',
  PROD: 'prod'
};
